import { useAppDispatch, useAppSelector } from 'store/hooks';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';
import { authApi } from 'components/auth/AuthApi';
import { SignUpForm } from 'components/auth/forms/SignUpForm';
import { MarketingLayout } from 'components/auth/MarketingLayout';
import { SignUpData } from 'components/auth/models/SignUpData';
import { FORGOT_YOUR_PASSWORD, SIGN_IN, USER_MERCHANTS } from 'config/routes';
import { signIn } from 'store/auth/authSlice';
import { Link } from 'ui/Link';
import logger from 'lib/logger';

export const SignUpPage: React.FC = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [error, setError] = React.useState<string>();
    const { error: signInError } = useAppSelector(state => state.auth);
    const handleSubmit = React.useCallback(
        async (data: SignUpData) => {
            const { email, password } = data;
            // Sign-up
            try {
                setError(undefined);
                const result = await authApi.signUp(data);
                if (!result.ok) {
                    setError(result.body && result.body.message);
                    throw new Error(result.body.message);
                }
                // Sign-in
                await dispatch(signIn(email, password));
                const params = new URLSearchParams(location.search);
                const redirectTo = params.get('redirectTo');
                navigate(redirectTo || USER_MERCHANTS);
            } catch (error) {
                logger.error(error);
            }
        },
        [dispatch, navigate, location.search]
    );
    return (
        <MarketingLayout
            after={
                <React.Fragment>
                    <Typography align="center" variant="caption" color="textSecondary">
                        <Link href={FORGOT_YOUR_PASSWORD}>Forgot your password? </Link>
                    </Typography>
                    <Typography align="center" variant="caption" color="textSecondary">
                        Already have an Account? <Link href={SIGN_IN}>Sign In</Link>
                    </Typography>
                </React.Fragment>
            }
        >
            <SignUpForm onSubmit={handleSubmit} error={error || signInError} />
        </MarketingLayout>
    );
};

export default SignUpPage;
